import { File, FileText, ImageOff } from 'lucide-react';
import { cn } from '@strivelabs/ui-core/lib/utils';
import { isImageType } from './libraryEntry';

/**
 * The mark a file without a picture is drawn with: a PDF's page in the
 * document red, anything else a plain sheet, and an image that cannot be
 * shown a crossed-out picture.
 *
 * @param mimeType - The file's mime type.
 *
 * @returns The icon and its tone.
 */
const glyphFor = (mimeType: string) => {
  if (isImageType(mimeType)) return { Icon: ImageOff, tone: 'text-v2-list-faint' };
  if (mimeType === 'application/pdf') return { Icon: FileText, tone: 'text-v2-destructive-text' };
  return { Icon: File, tone: 'text-v2-list-faint' };
};

export const FileGlyph = ({ mimeType, className }: { mimeType: string; className?: string }) => {
  const { Icon, tone } = glyphFor(mimeType);
  return <Icon className={cn(tone, className)} strokeWidth={1.6} aria-hidden />;
};
